import React, { Component } from 'react';
import { IoIosCheckmark } from "react-icons/io";
import PropTypes from 'prop-types';
import { Button, Col, Row } from 'react-bootstrap';
import PageContent from '../../../../reusable-components/PageContent';
import PageHeader from '../../../../reusable-components/PageHeader';
import '../../../../styles/finish.less';

export default class Finish extends Component {
  constructor(props){
    super(props);
  }

  render() {
    const { referenceNumber, finish, history } = this.props;

    return (
      <>
      <PageHeader title="Dank u wel !" />
      <PageContent 
        title=""
        goBack={() => {
        }}
        moveNext={() => {}}
        cardClass="card-container"
        showFooter={false}
        formClassNames=""
        handleSubmit={() => {}}>
        <div className="home-container">
          <div className="success-message text-center success-container">
            <Row>
              <Col md={12} className="finish-logo-container">
                <span 
                  className="instruction-circle logo">
                  <img src={require("../../../../assets/finish.png")} />
                </span>
                <span>Uw aanvraag is compleet.<br/> Uw referentienummer is <span style={{color: "red", margin: 0}}>{referenceNumber}</span><br/> U ontvangt een bevestiging per e-mail wanneer u aanvraag in behandeling wordt genomen.</span>
              </Col>
              <Col md={12}>
                <Button 
                  className="btn continue-btn"
                  onClick={() => {
                    finish()
                    history.push('/')
                  }}>Finish</Button>
              </Col>
            </Row>
          </div>
        </div>
      </PageContent>
      </>
    );
  }
}

